import React from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import css from './AdNetworksEmptyState.css';
import Label from '../foundations/Label';
import { EmptyStateBox, AutoComplete } from '.';
import { trackMixpanelEvent } from '../../utils/general';
import { adNetworkMap as specialNetworks, DEFAULT_INTERNAL_BI_PARTNER } from '../../utils/consts';
import DefaultOrgLogo from '../../../../dashboard/img/Singularlogo.png';

function AdNetworksEmptyState({
    adNetworkOptions = [],
    emptyStateAdNetworks = ['adwords', 'facebook', 'twitter', 'pinterest', 'snapchat', 'tiktok'],
    mixpanelPrefix,
    onAdNetworkSelectionChange = () => {},
    translationPageKey = 'DATA_SOURCES',
    translate = () => {},
    orgLogoPath = DefaultOrgLogo,
}) {
    const isAdNetworkDisabled = adnName => {
        const adNetwork = adNetworkOptions.find(option => option.value === adnName);
        return adNetwork?.isDisabled || false;
    };
    const getAdNetworkEmptyState = adnName => {
        const adNetwork = adNetworkOptions.find(option => option.value === adnName);

        if (!adNetwork) return null;

        const { value, label, logoPath } = adNetwork;
        return {
            title: label,
            image: [value === DEFAULT_INTERNAL_BI_PARTNER ? orgLogoPath : logoPath],
            name: value,
        };
    };

    const emptyStateBoxes = emptyStateAdNetworks
        .map(adnName => {
            const adnId = parseInt(adNetworkOptions.find(option => option.value === adnName)?.id, 10);
            if (!adnId) return null;
            const adNetwork = specialNetworks[adnName] || getAdNetworkEmptyState(adnName);

            const { title, image, name, style, disabledImage } = adNetwork;
            const disabled = isAdNetworkDisabled(adnName);
            return (
                <EmptyStateBox
                    disabled={disabled}
                    key={title}
                    title={`Add ${title}`}
                    image={disabled && disabledImage ? disabledImage : image}
                    imageStyle={style || {}}
                    onClick={() => {
                        trackMixpanelEvent(mixpanelPrefix, 'Empty State Logo Clicked', { name: adnId }, true);
                        onAdNetworkSelectionChange({ id: adnId, value: name });
                    }}
                />
            );
        })
        .filter(Boolean);

    return (
        <div className={css.noDataContainer}>
            <div className={css.textContainer}>
                <Label
                    className={css.emptyStateHeader}
                    text={`STATIC.PAGES.${translationPageKey}.EMPTY_STATE_HEADER`}
                />
                <Label
                    className={css.emptyStateSubHeader}
                    text={`STATIC.PAGES.${translationPageKey}.EMPTY_STATE_SUB_HEADER`}
                />
            </div>
            <AutoComplete
                placeholder={`STATIC.PAGES.${translationPageKey}.EMPTY_STATE_NEW_UAN_PLACEHOLDER`}
                selectOptions={{
                    options: adNetworkOptions.map(option => {
                        const hoverText = option.isDisabled
                            ? translate(`STATIC.PAGES.${translationPageKey}.UNAVAILABLE_SHORT`)
                            : translate(`STATIC.PAGES.${translationPageKey}.EMPTY_STATE_DROPDOWN_HOVER`);
                        return {
                            ...option,
                            extraOnHover: hoverText,
                        };
                    }),
                }}
                onChange={value => onAdNetworkSelectionChange(value)}
                onInputChange={text => {
                    trackMixpanelEvent(mixpanelPrefix, 'Empty State New UAN Search', { name: text }, true);
                }}
                searchable
                containerStyle={{
                    width: '620px',
                }}
                controlledValue=""
                big
            />
            {emptyStateBoxes.length > 0 && (
                <>
                    <Label
                        className={css.topConnectorsText}
                        text={`STATIC.PAGES.${translationPageKey}.CHOOSE_TOP_NETWORK`}
                    />
                    <div className={css.emptyStateBoxesContainer}>{emptyStateBoxes}</div>
                </>
            )}
        </div>
    );
}

AdNetworksEmptyState.propTypes = {
    translate: PropTypes.func,
    adNetworkOptions: PropTypes.arrayOf(PropTypes.any),
    emptyStateAdNetworks: PropTypes.arrayOf(PropTypes.number),
    translationPageKey: PropTypes.string,
    mixpanelPrefix: PropTypes.string.isRequired,
    onAdNetworkSelectionChange: PropTypes.func,
    orgLogoPath: PropTypes.string,
};

export default withLocalize(AdNetworksEmptyState);
